function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  d: "M37.73 33.68V29.3a8 8 0 10-8.33-13.63A12 12 0 109.73 27.31v4.91a16 16 0 1122-21.63 12.25 12.25 0 012-.21 12 12 0 014 23.3zm-22-7.3a2 2 0 11-2 2 2 2 0 012-2zm0 8a2 2 0 11-2 2 2 2 0 012-2zm8-4a2 2 0 11-2 2 2 2 0 012-2zm0 8a2 2 0 11-2 2 2 2 0 012-2zm8-12a2 2 0 11-2 2 2 2 0 012-2zm0 8a2 2 0 11-2 2 2 2 0 012-2z"
});

var SvgSnow = function SvgSnow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 46.83 44.17",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSnow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/snow.f09155d2.svg";
export { ForwardRef as ReactComponent };